import { Controller } from "@hotwired/stimulus"

// Live-updates the mini calendar preview as the owner picks a program color
// or types a name. Color/icon radios submit without JS.
export default class extends Controller {
  static targets = ["chip", "chipName", "nameField"]
  static values = { fallbackName: { type: String, default: "Your class" } }

  connect() {
    this.syncName()
  }

  colorChanged(event) {
    const color = event.currentTarget.value
    if (!color) return

    this.chipTargets.forEach((chip) => {
      chip.style.backgroundColor = color
      chip.style.borderLeftColor = color
    })
  }

  nameChanged() {
    this.syncName()
  }

  syncName() {
    if (!this.hasNameFieldTarget) return

    const name = this.nameFieldTarget.value.trim() || this.fallbackNameValue
    this.chipNameTargets.forEach((el) => {
      el.textContent = name
    })
  }
}
